'use es6';

export const NONE = 'none';
export const EXISTING_DASHBOARD = 'existing-dashboard';
export const NEW_DASHBOARD = 'new-dashboard';
export const DESTINATION_TYPE_LIST = [NONE, EXISTING_DASHBOARD, NEW_DASHBOARD];